export default "/fonts/poppins-v9-latin-500.eot?cf75a7f143e2e2c582c125840a660ba7";